import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// atom — DWR sheet chip: chip HP/Carico/Danno/Armatura per Hub FullSheet.
// Pattern .sheet-chip mockup (styles.css 1855-1869):
// container = border 1px ink + padding 0.4rem + font-display + text-center
// label    = inline ink-filled box (NON full-width), font 0.65rem
// value    = numero grande sotto, font 1.2rem bold
// near-duplicate of future <Chip>, consider unifying when stat-chip / meta-chip /
// spell-tag are extracted (PR 4-7 di Fase 2).

interface SheetChipProps {
  label: string;
  value: ReactNode;
  className?: string;
}

export function SheetChip({ label, value, className }: SheetChipProps) {
  return (
    <div
      className={cn(
        'border-ink font-display flex flex-col items-center border p-[0.4rem] text-center',
        className,
      )}
    >
      <span className="bg-ink text-paper-bright inline-block px-[0.4em] py-[0.1em] text-[0.65rem] tracking-[0.1em] uppercase">
        {label}
      </span>
      <span className="pt-1 text-[1.2rem] font-bold">{value}</span>
    </div>
  );
}
